import { memo,useRef } from "react";



const BzButton = ({ persist,className, type = 'button', ...props }) => {


const ref = useRef()

const handleBlur = ()=>{
    if(persist){
        ref?.current?.focus()
    }
}

    return (
        <button onBlur={handleBlur} ref={ref} type={type} className={className} {...props}>
            {props.children}
        </button>
    );
};

export default memo(BzButton);

